import React, { useState } from 'react';
import Layout from '../components/Layout';
import PageTitle from '../components/PageTitle';
import { Form, TextArea, TextInput, Status } from '../components/forms/StyledForm';
import { Button } from '../components/button/Button';
import { graphql } from "gatsby";
import IG from '../img/ig-icon.png';
import FB from '../img/fb-icon.png';
import * as Yup from 'yup';
import { Formik } from 'formik';
import { EmailRequest } from "../sendgrid/EmailRequest";
import { sendSendGridEmail } from "../sendgrid/SendGridEmailClient";
import { Details, Social, Row } from "../components/contact/Styled";
import Spinner from "../components/Spinner/Spinner";

const initialState = {
    isError: false,
    isPending: false,
    isSuccess: false,
    showStatus: false,
};

const FormSchema = Yup.object().shape({
    email: Yup.string()
        .email('Invalid email format')
        .required('Email cannot be empty'),
    title: Yup.string()
        .min(2, 'Title has to be longer than 2 characters')
        .max(50, 'Too long title.')
        .required('Title cannot be empty'),
    message: Yup.string()
        .min(2, 'Message has to be longer than 2 characters')
        .max(1000, 'Too long message, keep things short and sweet')
        .required('Message cannot be empty'),
});

const ContactPage = ({ data }) => {
    const { title, number, email: emailAddress, facebook, instagram } = data.markdownRemark.frontmatter
    const initialFormValues = { email: '', title: '', message: '' };
    const [emailStatus, setEmailStatus] = useState(initialState);

    function sendEmail(values) {
        setEmailStatus({
            ...emailStatus,
            isPending: true,
        });
        const request = new EmailRequest(
            { email: values.email, name: values.name },
            emailAddress,
            values.type,
            values.message
        );
        sendSendGridEmail(request)
            .then(() => {
                setEmailStatus({
                    ...emailStatus,
                    isPending: false,
                    isSuccess: true,
                    showStatus: true,
                });
            })
            .catch(() => {
                setEmailStatus({
                    isError: true,
                    isPending: false,
                    isSuccess: false,
                    showStatus: true,
                });
            });
    }

    function acceptSendStatus() {
        setEmailStatus({
            ...emailStatus,
            showStatus: false,
        });
    }

    const showEmailStatus = (isSuccess) => {
        return isSuccess ? (
            <Status>
                <h1 style={{ color: 'green' }}>Thank you for contacting us!</h1>
                <h3>We are going to contact you as fast as we can.</h3>
                <h3>Stay safe !</h3>
                <Button onClick={() => acceptSendStatus()}>Close</Button>
            </Status>
        ) : (
            <Status>
                <h2>What about a call ?</h2>
                <h4>Unfortunatelly, we cannot send the message now.</h4>
                <h4>Let's talk about your case: <a href={number}>{number}</a></h4>
                <Button onClick={() => acceptSendStatus()}>
                    Try again
                </Button>
            </Status>
        );
    };

    return (
        <Layout>
            <PageTitle>{title}</PageTitle>
            <Row>
                {emailStatus.showStatus === true ? showEmailStatus(emailStatus.isSuccess) : undefined}
                {emailStatus.isPending === true ? (
                    <Status>
                        <Spinner />
                        <h3>Sending</h3>
                    </Status>
                ) : undefined}
                {emailStatus.isPending === false && emailStatus.showStatus === false ? (
                    <Formik
                        initialValues={initialFormValues}
                        validationSchema={FormSchema}
                        onSubmit={(values) => sendEmail(values)}
                        render={({ errors, values, handleChange, handleBlur, handleSubmit }) => (
                            <Form onSubmit={handleSubmit}>
                                <TextInput
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.email}
                                    isValidated={!errors.email}
                                    type="text"
                                    name="email"
                                    placeholder={errors.email ? errors.email : 'Email'}
                                />
                                <TextInput
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.title}
                                    isValidated={!errors.title}
                                    type="text"
                                    name="title"
                                    placeholder={errors.title ? errors.title : 'Title'}
                                />
                                <TextArea
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.message}
                                    isValidated={!errors.message}
                                    name="message"
                                    placeholder={errors.message ? errors.message : 'Message'}
                                />
                                <Button type='submit'>SEND</Button>
                            </Form>
                        )}
                    />
                ) : undefined}
                <Details>
                    <Social>
                        <a>tel. </a><a href={number}>{number}</a>
                    </Social>
                    <Social>
                        <a>email. </a><a href={emailAddress}>{emailAddress}</a>
                    </Social>
                    <Social>
                        <img src={FB} alt='facebook' style={{ marginRight: '6px' }} />
                        <a href={facebook}>facebook</a>
                    </Social>
                    <Social>
                        <img src={IG} alt='instagram' style={{ marginRight: '6px' }} />
                        <a href={instagram}>instagram</a>
                    </Social>
                </Details>
            </Row>.
        </Layout>
    );
};
export default ContactPage;

export const contactPageQuery = graphql`
{
    markdownRemark(frontmatter: {templateKey: {eq: "contact-page"}}) {
      frontmatter {
        templateKey
        title
        number
        email
        instagram
        facebook
      }
    }
  }  
`;
